import { useEffect, useState } from "react";
import { useDashboardActions } from "../../../lib/useDashboardActions";
import { useAuth } from "@/features/Auth/lib/useAuth";
import { useDashboard } from "../../../lib/useDashboard";
import { usePlan } from "@/entities/Plan";
import { getInitialBoolean, getInitialString } from "@/shared/lib/localStorage";
import { ObjectTopItem } from "../_shared/ObjectTop/ObjectTop";
import { canSeeCommercialOverview } from '@/features/Auth/lib/salesAccess';

const useLTWCompany = () => {
  const { isAuth, user } = useAuth();
  const {
    loading,
    error,
    dateStart,
    dateEnd,
    selectedDepartment,
    setDashboardLTWCompany,
    dashboardLTWCompany: result,
  } = useDashboard();
  const { getLTWCompany } = useDashboardActions();

  const isDirector = canSeeCommercialOverview(user);
  const isHeader = (user?.bx?.sub_users?.length ?? 0) > 0 || user?.bx?.department?.some((d) => d.role === "head");

  const departmentIdForLtw = isDirector
    ? 0
    : isHeader && selectedDepartment != null && selectedDepartment !== ""
      ? Number(selectedDepartment)
      : (user?.bx?.department?.[0]?.id ?? 0);

  // --- localStorage key ---
  const LS_IS_PERIOD_KEY = 'ltwCompany_isPeriod';
  const LS_MIN_VALUE_KEY = 'ltwCompany_minValue';

  const [isPeriod, setIsPeriodState] = useState<boolean>(getInitialBoolean(LS_IS_PERIOD_KEY, false));
  const [minValue, setMinValueState] = useState<string>(getInitialString(LS_MIN_VALUE_KEY, ''));

  // --- эффекты для записи в localStorage ---
  useEffect(() => {
    localStorage.setItem(LS_IS_PERIOD_KEY, String(isPeriod));
  }, [isPeriod]);

  useEffect(() => {
    localStorage.setItem(LS_MIN_VALUE_KEY, minValue);
  }, [minValue]);

  const { loading: planLoading } = usePlan();

  useEffect(() => {
    if (isAuth && dateStart && dateEnd) {
      getLTWCompany({
        dateStart,
        dateEnd,
        isPeriod,
        departmentId: departmentIdForLtw,
      }).then((res) => {
        setDashboardLTWCompany(res);
      });
    }
    // eslint-disable-next-line
  }, [isAuth, dateStart, dateEnd, isPeriod, selectedDepartment, departmentIdForLtw]);

  const top6 = result.slice(0, 6);

  let top = top6;
  if (result.length > 0 && result.length < 6) {
    const emptyCount = 6 - result.length;
    top = [
      ...top6,
      ...Array.from({ length: emptyCount }, (_, i) => ({
        inn: '',
        total: 0,
        place: result.length + i + 1,
        name: '',
        isEmpty: true
      })) 
    ];
  }

  // fullMessage
  let fullMessage: string | undefined = undefined;
  if (!loading.dashboardLTWCompany && result.length === 0) {
    fullMessage = "Нет продаж в выбранный период";
  }

  return {
    top: top,
    result,
    loading: loading.dashboardLTWCompany || planLoading.planTypes,
    error: error.dashboardLTWCompany,
    fullMessage,
    isPeriod,
    setIsPeriod: setIsPeriodState,
    minValue,
    setMinValue: setMinValueState
  }
}

export default useLTWCompany
